/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdatePersonAddressRequest } from "../types/UpdatePersonAddressRequest.ts";

export const updatePersonAddressRequestSchema = z.object({
  street: z
    .string()
    .describe("Nome do logradouro (rua, avenida, etc.). Opcional.")
    .nullish(),
  zipCode: z.string().describe("CEP do endereço. Opcional.").nullish(),
  placeNumber: z
    .string()
    .describe("Número do imóvel no logradouro. Opcional.")
    .nullish(),
  neighborhood: z.string().describe("Bairro do endereço. Opcional.").nullish(),
  complement: z
    .string()
    .describe("Complemento do endereço (apartamento, bloco, etc.). Opcional.")
    .nullish(),
  countryId: z.optional(z.number().int().describe("ID do país do endereço.")),
  stateId: z
    .number()
    .int()
    .describe("ID do estado associado ao endereço. Opcional.")
    .nullish(),
  cityId: z
    .number()
    .int()
    .describe("ID da cidade associada ao endereço. Opcional.")
    .nullish(),
  stateName: z
    .string()
    .describe(
      "Nome do estado do endereço (texto livre, utilizado quando o estado não está cadastrado). Opcional.",
    )
    .nullish(),
  cityName: z
    .string()
    .describe(
      "Nome da cidade do endereço (texto livre, utilizado quando a cidade não está cadastrada). Opcional.",
    )
    .nullish(),
  postCode: z
    .string()
    .describe("Código postal internacional do endereço. Opcional.")
    .nullish(),
}) as unknown as ToZod<UpdatePersonAddressRequest>;
